import React, { useState } from 'react'
import { Gift } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '../ui'
import { ModernInput, ModernButton } from '../ui'
import { PriceInput } from '../form'
import { Benefit, BenefitFormData } from '../../types'
import { formatCurrency, parseCurrency } from '../../utils/formatters'

interface BenefitFormProps {
 benefit?: Benefit | null
 onSubmit: (data: BenefitFormData) => void
 onCancel: () => void
 isSubmitting?: boolean
}

export const BenefitForm: React.FC<BenefitFormProps> = ({
 benefit,
 onSubmit,
 onCancel,
 isSubmitting = false
}) => {
 const [formData, setFormData] = useState<BenefitFormData>({
 name: benefit?.name || '',
 value: benefit?.value || 0
 })

 const [valueInput, setValueInput] = useState<string>(
 benefit?.value ? formatCurrency(benefit.value) : ''
 )

 const handleInputChange = (field: keyof BenefitFormData, value: any) => {
 setFormData(prev => ({
 ...prev,
 [field]: value
 }))
 }

 const handleSubmit = (e: React.FormEvent) => {
 e.preventDefault()
 onSubmit(formData)
 }

 const handleValueChange = (value: string) => {
 setValueInput(value)
 const numericValue = parseCurrency(value)
 handleInputChange('value', numericValue)
 }

 return (
 <form onSubmit={handleSubmit} className="space-y-6">
 <Card>
 <CardHeader>
 <CardTitle className="flex items-center gap-2">
 <Gift className="h-5 w-5"/>
 Dados do Benefício
 </CardTitle>
 </CardHeader>
 <CardContent className="space-y-4">
 <div>
 <label className="block text-sm font-medium text-foreground mb-2">
 Nome do Benefício *
 </label>
 <ModernInput
 value={formData.name}
 onChange={(e) => handleInputChange('name', e.target.value)}
 placeholder="Ex: Troca de Óleo"
 required
 />
 </div>

 <div>
 <label className="block text-sm font-medium text-foreground mb-2">
 Valor *
 </label>
<PriceInput
  value={valueInput}
  onChange={handleValueChange}
  placeholder="R$ 0,00"
  />
 </div>
 </CardContent>
 </Card>

 <div className="flex justify-end gap-3">
 <ModernButton
 type="button"
 variant="outline"
 onClick={onCancel}
 disabled={isSubmitting}
 >
 Cancelar
 </ModernButton>
 <ModernButton
 type="submit"
 disabled={isSubmitting || !formData.name || formData.value <= 0}
 >
 {isSubmitting ? 'Salvando...' : benefit ? 'Atualizar' : 'Criar'}
 </ModernButton>
 </div>
 </form>
 )
}

